import {
  Flex,
  FlexProps,
  HStack,
  StackDivider,
  StackProps,
  StyleProps,
  Text,
  VStack,
} from "@chakra-ui/react";

export const CardSectionGroup: React.FC<
  React.PropsWithChildren<StackProps>
> = ({ children, ...props }) => (
  <HStack
    className="mb-card-section-group"
    divider={<StackDivider />}
    alignItems="space-between"
    spacing="0"
    flexGrow="1"
    {...props}
  >
    {children}
  </HStack>
);

export const CardSection: React.FC<React.PropsWithChildren<StyleProps>> = ({
  children,
  ...props
}) => (
  <VStack
    className="mb-card-section"
    alignItems="space-between"
    justifyContent="center"
    spacing="0"
    {...props}
  >
    {children}
  </VStack>
);

export const CardSectionTitle: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <Text
    className="mb-card-section-title"
    textStyle="overline"
    mt="8px"
    ml="-16px"
    marginBottom="auto"
    color="gray.400"
    alignSelf="flex-start"
    justifySelf="flex-start"
    display="flex"
  >
    {children}
  </Text>
);

export const CardSectionBody: React.FC<React.PropsWithChildren<FlexProps>> = ({
  children,
  ...props
}) => (
  <Flex
    className="mb-card-section-body"
    flexGrow="1"
    alignItems="center"
    {...props}
  >
    {children}
  </Flex>
);
